import {XauditModel} from '../xaudit.model';
import {NotificationDestinationDataModel} from './notification-destination-data.model';

export class NotificationDataModel extends XauditModel {
  NotificationID: string;
  SenderUserID: string;
  isSystem: boolean;
  isPopUp: boolean;
  Message: string;
  PopMessage: string;
  enumNotificationStatusID: string;
  isAllDestinationMustRead: boolean = true;
  enumNotificationPriorityID: string;
  enumNotificationMsgTypeID: string;

  dataNotificationDestinations: NotificationDestinationDataModel[] = [];
}
